export const GET_COURSE_COUNT = 'GET_COURSE_COUNT';
export const GET_CLASS_SCHEDULE = 'GET_CLASS_SCHEDULE';
export const GET_TEACH_LIST = 'GET_TEACH_LIST';
export const GET_COURSE_LIST = 'GET_COURSE_LIST';
export const IS_USERCENTER = 'IS_USERCENTER';


// WEBPACK FOOTER //
// ./src/redux/type/UserCenter.type.js